import React, { useState } from "react";
import { FilePlus2, Files } from "lucide-react";
import { useLocation, useNavigate } from "react-router-dom";
import ActiveQuotationForm from "../components/quotation/ActiveQuotationForm";
import { Button } from "../components/ui/button";
import { createQuotationDraft } from "../lib/activeQuotation";

export default function QuotationCreateChoice() {
  const navigate = useNavigate();
  const location = useLocation();
  const [draft, setDraft] = useState(() => createQuotationDraft(""));
  const choose = (type) => navigate(`/quotations/create/${type}`, { state: location.state });
  const choices = (
    <section className="flex min-w-0 flex-col rounded-lg border bg-card shadow-brutal lg:aspect-video" data-testid="quotation-choice-section">
      <header className="border-b p-4" data-testid="quotation-section-one-header">
        <h2 className="text-lg font-semibold">1. Service Item</h2>
      </header>
      <div className="grid min-w-0 flex-1 items-stretch gap-4 p-4 md:grid-cols-2">
        <article className="flex min-w-0 flex-col items-center justify-center rounded-lg border border-dashed px-6 py-12 text-center" data-testid="quotation-choice-mq">
          <Files className="h-12 w-12 text-primary" strokeWidth={1.5} />
          <h3 className="mt-4 text-xl font-semibold">Multi Quotation (MQ)</h3>
          <p className="mt-2 max-w-sm text-sm text-muted-foreground">Combine eligible Service Tickets from the same Branch.</p>
          <Button type="button" className="mt-6" variant="navigation-forward" onClick={() => choose("mq")}><Files />Select Service Tickets</Button>
        </article>
        <article className="flex min-w-0 flex-col items-center justify-center rounded-lg border border-dashed px-6 py-12 text-center" data-testid="quotation-choice-cq">
          <FilePlus2 className="h-12 w-12 text-primary" strokeWidth={1.5} />
          <h3 className="mt-4 text-xl font-semibold">Custom Quotation (CQ)</h3>
          <p className="mt-2 max-w-sm text-sm text-muted-foreground">Create a standalone quotation without a Service Ticket.</p>
          <Button type="button" className="mt-6" variant="navigation-forward" onClick={() => choose("cq")}><FilePlus2 />Manual Entry</Button>
        </article>
      </div>
    </section>
  );

  return (
    <div data-testid="quotation-create-choice">
      <ActiveQuotationForm
        mode="create"
        draft={draft}
        setDraft={setDraft}
        selectionPrimary={choices}
        onBack={() => navigate(location.state?.quotationHistoryReturn || "/quotations")}
      />
    </div>
  );
}
